import { c as _c } from "react/compiler-runtime";
import { useI18n } from '~/features/i18n';

/** The four reasons to book through Funkey, shared by the bar above the
 * results and the card the control group still sees between them. */
export function usePlpUsps() {
  const $ = _c(33);
  const i18n = useI18n();
  let t0;
  if ($[0] !== i18n) {
    t0 = i18n._("usp1.title");
    $[0] = i18n;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== i18n) {
    t1 = i18n._("usp1.description");
    $[2] = i18n;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      title: t0,
      description: t1,
      icon: "chill" as const
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== i18n) {
    t3 = i18n._("usp2.title");
    $[7] = i18n;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== i18n) {
    t4 = i18n._("usp2.description");
    $[9] = i18n;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = {
      title: t3,
      description: t4,
      icon: "workshop" as const
    };
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== i18n) {
    t6 = i18n._("usp3.title");
    $[14] = i18n;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== i18n) {
    t7 = i18n._("usp3.description");
    $[16] = i18n;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = {
      title: t6,
      description: t7,
      icon: "quality" as const
    };
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== i18n) {
    t9 = i18n._("usp4.title");
    $[21] = i18n;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== i18n) {
    t10 = i18n._("usp4.description");
    $[23] = i18n;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t9) {
    t11 = {
      title: t9,
      description: t10,
      icon: "number1" as const
    };
    $[25] = t10;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t11 || $[29] !== t2 || $[30] !== t5 || $[31] !== t8) {
    t12 = [t2, t5, t8, t11];
    $[28] = t11;
    $[29] = t2;
    $[30] = t5;
    $[31] = t8;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  return t12;
}